<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-bg-colors`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 40a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4a1 1 0 011-1h38zM21.347 2.172l15.335 15.334a1.906 1.906 0 010 2.696L21.697 35.186a1.906 1.906 0 01-2.695 0L6.478 22.663a1.906 1.906 0 010-2.696L20.091 6.354l-1.464-1.462a.953.953 0 010-1.348L20 2.172a.953.953 0 011.347 0zm15.841 23.863l2.695 2.816c1.49 1.556 1.49 4.078 0 5.634a3.697 3.697 0 01-5.39 0c-1.489-1.556-1.489-4.078 0-5.634l2.695-2.816zM22.786 9.05l-12.24 12.24.959.959 17.82-.081 3.29-3.29-9.83-9.828z"/></svg>
</template>
<script>

export default {
  name: 'IconBgColors',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
